import {
  takeLatest,
  put,
  all,
} from 'redux-saga/effects';
import * as types from './types';
import * as baseTypes from './base/types';
import * as birdChartTypes from './birdChart/types';
import * as errorTableTypes from './errorTable/types';
import * as dimensionTablesTypes from './dimensionTables/types';
import * as barChartTypes from './barChart/types';
import * as tempDashboardTypes from './tempDashboard/types';
import * as dashboardTypes from './dashboard/types';
import { sagas as baseSagas } from './base';
import { sagas as birdChartSagas } from './birdChart';
import { sagas as errorTableSagas } from './errorTable';
import { sagas as dimensionTablesSagas } from './dimensionTables';
import { sagas as barChartSagas } from './barChart';
import { sagas as sharingSagas } from './sharing';
import { sagas as dashboardSagas } from './dashboard';
import { sagas as tempDashboard } from './tempDashboard';

function* init() {
  yield all([
    put({ type: birdChartTypes.INIT }),
    put({ type: errorTableTypes.INIT }),
    put({ type: dimensionTablesTypes.INIT }),
    put({ type: barChartTypes.INIT }),
    put({ type: tempDashboardTypes.INIT }),
    put({ type: dashboardTypes.INIT }),
    put({ type: baseTypes.INIT }),
  ]);
}


function* watchInit() {
  yield takeLatest([
    types.INIT,
  ], init);
}

export default [
  watchInit,
  ...baseSagas,
  ...birdChartSagas,
  ...errorTableSagas,
  ...dimensionTablesSagas,
  ...barChartSagas,
  ...sharingSagas,
  ...dashboardSagas,
  ...tempDashboard,
];
